/**
 * Lampenwerk24 – Desktop Mega-Menü + Mobile (More Nutrition Style) v13
 *
 * DESKTOP:
 * 1) Such-Trigger in .header__icons verschieben
 * 2) Such-Modal: Klick öffnet zentriertes Popup
 * 3) Scroll-Lock wenn Modal offen
 * 4) Klick auf Backdrop schließt Modal
 * 5) Account-Icon per JS ersetzen
 * 6) Zuletzt gesehen (localStorage) / Beliebte Produkte
 * 7) Predictive Search
 * 8) CLICK Nav-Dropdowns
 *
 * MOBILE:
 * 9) Header fixup: Logo zentriert, Lupe+Warenkorb rechts
 * 10) Fullscreen Search Panel (slide-in wie More Nutrition)
 * 11) Predictive Search im Mobile Panel
 */
(function () {
  'use strict';

  var BREAKPOINT = 990;
  var overlay = null;

  function init() {
    // Modals und Mobile-Elemente aus dem Header herausnehmen (Layout-Fix)
    relocateElements();

    if (window.innerWidth >= BREAKPOINT) {
      moveSearchToHeader();
      replaceAccountIcon();
    }
    window.addEventListener('resize', function () {
      if (window.innerWidth >= BREAKPOINT) {
        moveSearchToHeader();
        replaceAccountIcon();
      }
    });

    initSearchModal();
    initMobileHeader();
    initMobileSearchPanel();
    initNavigation();
    initSidebarPanels();
    initMobileNav();
    trackRecentlyViewed();
    loadDefaultProducts();
  }

  /* ── Elemente aus Header herausnehmen (brechen sonst das Flex-Layout) ── */
  function relocateElements() {
    var header = document.querySelector('.header.page-width');
    if (!header) return;

    // Such-Modal → body (ist ein Overlay, gehört nicht in den Header)
    var modal = header.querySelector('[data-lw-search-modal]');
    if (modal) document.body.appendChild(modal);

    // Mobile Panel → body
    var panel = header.querySelector('[data-lw-mobile-panel]');
    if (panel) document.body.appendChild(panel);

    // Mobile Suchleiste → INNERHALB der Section, aber NACH .header.page-width
    // (bleibt so Teil des sticky Headers)
    var mobileSearch = header.querySelector('[data-lw-mobile-search]');
    if (mobileSearch) {
      var headerSection = header.closest('.shopify-section') || header.parentElement;
      if (headerSection) {
        headerSection.appendChild(mobileSearch);
      }
    }
  }

  /* ── Such-Trigger in Header-Icons verschieben ────────────────────── */
  function moveSearchToHeader() {
    var trigger = document.querySelector('[data-lw-search-trigger]');
    var headerIcons = document.querySelector('.header__icons');
    if (!trigger || !headerIcons) return;
    if (trigger.parentElement === headerIcons) return;
    headerIcons.insertBefore(trigger, headerIcons.firstChild);
  }

  /* ── Account-Icon ersetzen (More Nutrition Style) ────────────────── */
  function replaceAccountIcon() {
    var accountLink = document.querySelector('.header__icon--account');
    if (!accountLink || accountLink.dataset.lwIconReplaced) return;

    var svgWrapper = accountLink.querySelector('account-icon') || accountLink.querySelector('.svg-wrapper');
    if (svgWrapper) {
      svgWrapper.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.0" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21v-1a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v1"/></svg>';
    }
    accountLink.dataset.lwIconReplaced = 'true';
  }

  /* ── Drawer: X-Button, Backdrop, Scroll-Lock ── */
  function initDrawerScrollLock() {
    var headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    var details = headerDrawer.querySelector('details');
    if (!details) return;

    var scrollY = 0;

    // --- Eigenes Backdrop-Overlay erstellen (zuverlässiger als Dawn's) ---
    var backdrop = document.createElement('div');
    backdrop.className = 'lw-drawer-backdrop';
    document.body.appendChild(backdrop);

    // --- Eigenen X-Button erstellen – AUSSERHALB des Drawers (rechts daneben, wie More Nutrition) ---
    var closeBtn = document.createElement('button');
    closeBtn.className = 'lw-drawer-close';
    closeBtn.setAttribute('aria-label', 'Menü schließen');
    closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    closeBtn.style.display = 'none';
    // X-Button auf body (über dem Backdrop, rechts neben dem Drawer)
    document.body.appendChild(closeBtn);

    // X-Button und Backdrop schließen den Drawer
    function closeDrawer() {
      if (details.hasAttribute('open')) {
        // Dawn's close-Mechanismus auslösen
        var summary = details.querySelector('summary');
        if (summary) summary.click();
      }
    }
    closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);

    // Touch-Events auf Body blockieren
    function preventBodyScroll(e) {
      var menuDrawer = document.querySelector('.menu-drawer');
      if (menuDrawer && menuDrawer.contains(e.target)) return;
      if (closeBtn.contains(e.target)) return;
      e.preventDefault();
    }

    // Header-Section: z-index beim Öffnen hochsetzen damit Drawer ÜBER dem Backdrop liegt
    var headerSection = details.closest('.shopify-section-group-header-group') || details.closest('.shopify-section');

    // MutationObserver: reagiert wenn <details> open-Attribut sich ändert
    var observer = new MutationObserver(function () {
      if (details.hasAttribute('open')) {
        scrollY = window.scrollY;
        document.documentElement.classList.add('overflow-hidden-mobile');
        document.body.classList.add('overflow-hidden-mobile');
        document.body.style.top = '-' + scrollY + 'px';
        backdrop.classList.add('lw-drawer-backdrop--visible');
        closeBtn.style.display = 'flex';
        // Header-Section z-index hochsetzen → Drawer über dem Backdrop
        if (headerSection) {
          headerSection.style.zIndex = '300';
          headerSection.style.position = 'relative';
        }
        document.addEventListener('touchmove', preventBodyScroll, { passive: false });
        // Login-Icon beim Öffnen ersetzen (falls noch nicht geschehen)
        replaceLoginIcon();
      } else {
        document.documentElement.classList.remove('overflow-hidden-mobile');
        document.body.classList.remove('overflow-hidden-mobile');
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
        backdrop.classList.remove('lw-drawer-backdrop--visible');
        closeBtn.style.display = 'none';
        // Header-Section z-index zurücksetzen
        if (headerSection) {
          headerSection.style.zIndex = '';
          headerSection.style.position = '';
        }
        document.removeEventListener('touchmove', preventBodyScroll);
      }
    });
    observer.observe(details, { attributes: true, attributeFilter: ['open'] });
  }

  /* ── Burger-Icon ersetzen (Dawn SVG nutzt fill, nicht stroke → zu dünn) ── */
  function replaceBurgerIcon() {
    var burgerBtn = document.querySelector('.header__icon--menu');
    if (!burgerBtn) return;
    var oldSvg = burgerBtn.querySelector('svg.icon-hamburger, svg');
    if (!oldSvg) return;
    // Neues stroke-basiertes SVG mit dicken Linien (2px stroke)
    var newSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    newSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    newSvg.setAttribute('viewBox', '0 0 20 16');
    newSvg.setAttribute('fill', 'none');
    newSvg.setAttribute('stroke', 'currentColor');
    newSvg.setAttribute('stroke-width', '2.2');
    newSvg.setAttribute('stroke-linecap', 'round');
    newSvg.setAttribute('class', 'icon icon-hamburger');
    newSvg.setAttribute('width', '22');
    newSvg.setAttribute('height', '22');
    newSvg.innerHTML = '<line x1="1" y1="2" x2="19" y2="2"/><line x1="1" y1="8" x2="19" y2="8"/><line x1="1" y1="14" x2="19" y2="14"/>';
    oldSvg.replaceWith(newSvg);
  }

  /* ── Login-Icon im Drawer: dickeres stroke-basiertes Person-SVG ── */
  function replaceLoginIcon() {
    var loginLinks = document.querySelectorAll('.menu-drawer [href*="account/login"], .menu-drawer [href*="account"]');
    loginLinks.forEach(function (link) {
      var oldSvg = link.querySelector('svg');
      if (!oldSvg || oldSvg.getAttribute('data-lw-replaced')) return;
      var newSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      newSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      newSvg.setAttribute('viewBox', '0 0 24 24');
      newSvg.setAttribute('fill', 'none');
      newSvg.setAttribute('stroke', 'currentColor');
      newSvg.setAttribute('stroke-width', '2.8');
      newSvg.setAttribute('stroke-linecap', 'round');
      newSvg.setAttribute('stroke-linejoin', 'round');
      newSvg.setAttribute('width', '28');
      newSvg.setAttribute('height', '28');
      newSvg.setAttribute('data-lw-replaced', '1');
      newSvg.innerHTML = '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>';
      oldSvg.replaceWith(newSvg);
    });
  }

  /* ══════════════════════════════════════════════════════════════════
     MOBILE HEADER (Logo zentriert, Lupe in Header-Icons)
     ══════════════════════════════════════════════════════════════════ */
  function initMobileHeader() {
    if (window.innerWidth >= BREAKPOINT) return;

    // Burger-Icon: Dawn nutzt fill-basierte Pfade (0.5px dünn) → ersetzen mit stroke-basiertem SVG
    replaceBurgerIcon();

    // Login-Icon im Drawer: dickeres stroke-SVG
    replaceLoginIcon();

    // Drawer Scroll-Lock: Body fixieren wenn Burger-Drawer offen
    initDrawerScrollLock();

    // Such-Icon in .header__icons einfügen (vor Account/Warenkorb)
    var headerIcons = document.querySelector('.header__icons');
    if (!headerIcons) return;

    // Prüfen ob es schon ein Mobile-Such-Icon gibt
    if (headerIcons.querySelector('[data-lw-mobile-search-trigger]')) return;

    var searchBtn = document.createElement('button');
    searchBtn.className = 'lw-mobile-search-icon';
    searchBtn.setAttribute('data-lw-mobile-search-trigger', '');
    searchBtn.setAttribute('aria-label', 'Suche öffnen');
    searchBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';

    // Vor dem ersten Icon einfügen
    headerIcons.insertBefore(searchBtn, headerIcons.firstChild);

    // Dawn's Account-Icon auf Mobile verstecken (nur Lupe + Warenkorb)
    var accountIcon = headerIcons.querySelector('.header__icon--account');
    if (accountIcon) accountIcon.classList.add('lw-hide-mobile');
  }

  /* ══════════════════════════════════════════════════════════════════
     MOBILE SEARCH PANEL (Fullscreen, wie More Nutrition)
     ══════════════════════════════════════════════════════════════════ */
  function initMobileSearchPanel() {
    var panel = document.querySelector('[data-lw-mobile-panel]');
    if (!panel) return;

    var panelInput = panel.querySelector('[data-lw-mobile-panel-input]');
    var backBtn = panel.querySelector('[data-lw-mobile-panel-back]');
    var productsContainer = panel.querySelector('[data-lw-mobile-panel-products]');

    // Öffnen via Mobile-Such-Icon in Header
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lw-mobile-search-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        openMobilePanel();
      }
    });

    // Auch via die Suchleiste unter dem Header öffnen (Tap-to-open)
    var oldSearchBar = document.querySelector('[data-lw-mobile-search] .lw-mobile-search__form');
    if (oldSearchBar) {
      oldSearchBar.addEventListener('click', function (e) {
        e.preventDefault();
        openMobilePanel();
      });
    }

    // Zurück-Button
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        closeMobilePanel();
      });
    }

    // Enter → Suchseite
    if (panelInput) {
      panelInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var query = panelInput.value.trim();
          if (query) {
            window.location.href = '/search?q=' + encodeURIComponent(query);
          }
        }
      });

      // Predictive Search
      var timer = null;
      panelInput.addEventListener('input', function () {
        clearTimeout(timer);
        var query = panelInput.value.trim();
        if (query.length < 2) {
          loadMobilePanelDefaults();
          return;
        }
        timer = setTimeout(function () { fetchMobilePredictive(query); }, 250);
      });
    }

    function openMobilePanel() {
      panel.classList.add('lw-mobile-panel--open');
      document.documentElement.classList.add('lw-no-scroll');
      document.body.classList.add('lw-no-scroll');
      loadMobilePanelDefaults();
      setTimeout(function () { if (panelInput) panelInput.focus(); }, 150);
    }

    function closeMobilePanel() {
      panel.classList.remove('lw-mobile-panel--open');
      document.documentElement.classList.remove('lw-no-scroll');
      document.body.classList.remove('lw-no-scroll');
      if (panelInput) panelInput.value = '';
    }

    function loadMobilePanelDefaults() {
      if (!productsContainer) return;
      var recent = getRecentlyViewed();
      var heading = panel.querySelector('.lw-mobile-panel__products-heading');
      if (recent.length > 0) {
        if (heading) heading.textContent = 'Zuletzt gesehen';
        renderMobileProducts(recent.slice(0, 5));
      } else {
        if (heading) heading.textContent = 'Beliebte Produkte';
        fetch('/search/suggest.json?q=*&resources[type]=product&resources[limit]=5')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = data.resources && data.resources.results && data.resources.results.products;
            if (products && products.length > 0) {
              var items = products.map(function (p) {
                return {
                  title: p.title, url: p.url, image: p.image || '',
                  price: p.price ? parseFloat(p.price).toFixed(2).replace('.', ',') + ' \u20AC' : ''
                };
              });
              renderMobileProducts(items);
            }
          }).catch(function () {});
      }
    }

    function fetchMobilePredictive(query) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5';
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products;
          var heading = panel.querySelector('.lw-mobile-panel__products-heading');
          if (products && products.length > 0) {
            if (heading) heading.textContent = 'Ergebnisse';
            var items = products.map(function (p) {
              return {
                title: p.title, url: p.url, image: p.image || '',
                price: p.price ? parseFloat(p.price).toFixed(2).replace('.', ',') + ' \u20AC' : ''
              };
            });
            renderMobileProducts(items);
          }
        }).catch(function () {});
    }

    function renderMobileProducts(items) {
      if (!productsContainer) return;
      var html = '';
      items.forEach(function (item) {
        var img = item.image ? '<img src="' + item.image + '" alt="" width="64" height="64" loading="lazy">' : '';
        html += '<a href="' + item.url + '" class="lw-mobile-panel__product">' +
          '<span class="lw-mobile-panel__product-img">' + img + '</span>' +
          '<span class="lw-mobile-panel__product-info">' +
          '<span class="lw-mobile-panel__product-title">' + item.title + '</span>' +
          (item.price ? '<span class="lw-mobile-panel__product-price">' + item.price + '</span>' : '') +
          '</span></a>';
      });
      productsContainer.innerHTML = html;
    }
  }

  /* ══════════════════════════════════════════════════════════════════
     DESKTOP SUCH-MODAL (zentriert, More Nutrition Style)
     ══════════════════════════════════════════════════════════════════ */
  function initSearchModal() {
    var trigger = document.querySelector('[data-lw-search-trigger]');
    var modal = document.querySelector('[data-lw-search-modal]');
    var modalInput = document.querySelector('[data-lw-search-modal-input]');
    if (!trigger || !modal || !modalInput) return;

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openSearchModal();
    });

    modal.addEventListener('click', function (e) {
      if (!e.target.closest('.lw-search-modal__container')) {
        closeSearchModal();
      }
    });

    var closeBtns = document.querySelectorAll('[data-lw-search-close]');
    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeSearchModal();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('lw-search-modal--open')) {
        closeSearchModal();
      }
    });

    modalInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var query = modalInput.value.trim();
        if (query) {
          window.location.href = '/search?q=' + encodeURIComponent(query);
        }
      }
    });

    var timer = null;
    modalInput.addEventListener('input', function () {
      clearTimeout(timer);
      var query = modalInput.value.trim();
      if (query.length < 2) {
        loadDefaultProducts();
        return;
      }
      timer = setTimeout(function () { fetchPredictive(query); }, 250);
    });

    function openSearchModal() {
      modal.classList.add('lw-search-modal--open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lw-no-scroll');
      document.body.classList.add('lw-no-scroll');
      setTimeout(function () { modalInput.focus(); }, 100);
    }

    function closeSearchModal() {
      modal.classList.remove('lw-search-modal--open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lw-no-scroll');
      document.body.classList.remove('lw-no-scroll');
      modalInput.value = '';
      loadDefaultProducts();
    }
  }

  /* ── Predictive Search (Desktop) ──────────────────────────────────── */
  function fetchPredictive(query) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=5';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.resources && data.resources.results && data.resources.results.products;
        if (products && products.length > 0) {
          renderApiProducts(products);
          updateHeading('Ergebnisse');
        }
      })
      .catch(function () {});
  }

  function renderApiProducts(products) {
    var items = products.map(function (p) {
      return {
        title: p.title, url: p.url, image: p.image || '',
        price: p.price ? parseFloat(p.price).toFixed(2).replace('.', ',') + ' \u20AC' : ''
      };
    });
    renderProducts(items);
  }

  function renderProducts(items) {
    var container = document.querySelector('[data-lw-search-products]');
    if (!container) return;
    var html = '';
    items.forEach(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="" width="52" height="52" loading="lazy">' : '';
      html += '<a href="' + item.url + '" class="lw-search-modal__product">' +
        '<span class="lw-search-modal__product-img">' + img + '</span>' +
        '<span class="lw-search-modal__product-info">' +
        '<span class="lw-search-modal__product-title">' + item.title + '</span>' +
        (item.price ? '<span class="lw-search-modal__product-price">' + item.price + '</span>' : '') +
        '</span></a>';
    });
    container.innerHTML = html;
  }

  function updateHeading(text) {
    var heading = document.querySelector('.lw-search-modal__col--products .lw-search-modal__heading');
    if (heading) heading.textContent = text;
  }

  /* ── Zuletzt gesehen / Beliebte Produkte (Desktop) ────────────────── */
  function loadDefaultProducts() {
    var recent = getRecentlyViewed();
    if (recent.length > 0) {
      updateHeading('Zuletzt gesehen');
      renderProducts(recent.slice(0, 5));
    } else {
      updateHeading('Beliebte Produkte');
      fetch('/search/suggest.json?q=*&resources[type]=product&resources[limit]=5')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products;
          if (products && products.length > 0) renderApiProducts(products);
        })
        .catch(function () {});
    }
  }

  function trackRecentlyViewed() {
    var ogType = document.querySelector('meta[property="og:type"]');
    if (!ogType) return;
    var typeVal = ogType.getAttribute('content') || '';
    if (typeVal !== 'product' && typeVal !== 'og:product') return;

    var titleEl = document.querySelector('meta[property="og:title"]');
    var imageEl = document.querySelector('meta[property="og:image"]');
    var priceEl = document.querySelector('meta[property="product:price:amount"]');
    if (!titleEl) return;

    var productData = {
      title: titleEl.getAttribute('content') || '',
      url: window.location.pathname,
      image: imageEl ? imageEl.getAttribute('content') : '',
      price: priceEl ? parseFloat(priceEl.getAttribute('content')).toFixed(2).replace('.', ',') + ' \u20AC' : ''
    };
    if (!productData.title) return;

    try {
      var key = 'lw_recently_viewed';
      var items = JSON.parse(localStorage.getItem(key) || '[]');
      items = items.filter(function (item) { return item.url !== productData.url; });
      items.unshift(productData);
      items = items.slice(0, 10);
      localStorage.setItem(key, JSON.stringify(items));
    } catch (e) {}
  }

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem('lw_recently_viewed') || '[]');
    } catch (e) { return []; }
  }

  /* ══════════════════════════════════════════════════════════════════
     NAV DROPDOWNS (CLICK)
     ══════════════════════════════════════════════════════════════════ */
  function initNavigation() {
    var triggers = document.querySelectorAll('[data-mega-trigger]');
    if (!triggers.length) return;

    overlay = document.createElement('div');
    overlay.className = 'lw-mega-overlay';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', closeAll);

    triggers.forEach(function (item) {
      var link = item.querySelector('.lw-mega-nav__link');
      if (!link) return;
      link.addEventListener('click', function (e) {
        if (window.innerWidth < BREAKPOINT) return;
        if (item.classList.contains('lw-mega-nav__item--has-dropdown')) {
          e.preventDefault(); e.stopPropagation();
          if (item.classList.contains('lw-mega-nav__item--open')) {
            closeItem(item);
          } else {
            closeAll(); openItem(item);
          }
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.lw-mega-nav__item--has-dropdown')) closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ── Sidebar Panel-Wechsel (Hover auf Sidebar-Items) ── */
  function initSidebarPanels() {
    var sidebars = document.querySelectorAll('[data-mega-sidebar]');
    sidebars.forEach(function (sidebar) {
      var dropdown = sidebar.closest('.lw-mega-dropdown');
      if (!dropdown) return;

      var items = sidebar.querySelectorAll('[data-mega-sidebar-item]');
      var panels = dropdown.querySelectorAll('[data-mega-panel]');

      items.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          var idx = item.getAttribute('data-panel-index');
          // Alle deaktivieren
          items.forEach(function (el) { el.classList.remove('lw-mega-sidebar__item--active'); });
          panels.forEach(function (el) { el.classList.remove('lw-mega-panel--active'); });
          // Aktives aktivieren
          item.classList.add('lw-mega-sidebar__item--active');
          var targetPanel = dropdown.querySelector('[data-mega-panel][data-panel-index="' + idx + '"]');
          if (targetPanel) targetPanel.classList.add('lw-mega-panel--active');
        });
      });
    });
  }

  var _activeDropdownItem = null;

  function _updateDropdownPosition() {
    if (!_activeDropdownItem) return;
    var dropdown = _activeDropdownItem.querySelector('.lw-mega-dropdown');
    var nav = _activeDropdownItem.closest('.lw-mega-nav');
    if (dropdown && nav) {
      var navRect = nav.getBoundingClientRect();
      dropdown.style.top = navRect.bottom + 'px';
    }
  }

  // Beim Scrollen: Dropdown-Position aktualisieren (Sticky-Header)
  window.addEventListener('scroll', _updateDropdownPosition, { passive: true });

  function openItem(item) {
    item.classList.add('lw-mega-nav__item--open');
    var link = item.querySelector('.lw-mega-nav__link');
    if (link) link.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('lw-mega-overlay--active');
    _activeDropdownItem = item;
    _updateDropdownPosition();
  }

  function closeItem(item) {
    item.classList.remove('lw-mega-nav__item--open');
    var link = item.querySelector('.lw-mega-nav__link');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('lw-mega-overlay--active');
    if (_activeDropdownItem === item) _activeDropdownItem = null;
  }

  /* ── Mobile Navigation: A-Layer / B-Layer Slide (More Nutrition Style) ── */
  function initMobileNav() {
    var container = document.querySelector('[data-lw-mnav]');
    if (!container) return;

    var layerA = container.querySelector('[data-lw-mnav-layer="a"]');
    if (!layerA) return;

    // Klick auf Kategorie → B-Layer öffnen
    var openBtns = container.querySelectorAll('[data-lw-mnav-open]');
    openBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();  // Verhindert, dass Dawn den Drawer schließt
        e.stopImmediatePropagation();
        var idx = btn.getAttribute('data-lw-mnav-open');
        var panel = container.querySelector('[data-lw-mnav-panel="' + idx + '"]');
        if (!panel) return;

        // A-Layer ausblenden, B-Layer einblenden
        layerA.classList.add('lw-mnav__layer--pushed');
        layerA.classList.remove('lw-mnav__layer--active');
        panel.classList.add('lw-mnav__layer--active');
        panel.scrollTop = 0;
      });
    });

    // Zurück-Buttons → B-Layer schließen
    var backBtns = container.querySelectorAll('[data-lw-mnav-back]');
    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var panel = btn.closest('[data-lw-mnav-panel]');
        if (!panel) return;

        // B-Layer raussliden
        panel.classList.remove('lw-mnav__layer--active');

        // A-Layer zurückholen
        layerA.classList.remove('lw-mnav__layer--pushed');
        layerA.classList.add('lw-mnav__layer--active');
      });
    });

    // Wenn der Drawer geschlossen wird → alle Panels zurücksetzen
    var drawerDetails = document.querySelector('header-drawer details');
    if (drawerDetails) {
      var drawerObserver = new MutationObserver(function () {
        if (!drawerDetails.hasAttribute('open')) {
          // Alle B-Layers schließen
          container.querySelectorAll('[data-lw-mnav-panel]').forEach(function (p) {
            p.classList.remove('lw-mnav__layer--active');
          });
          layerA.classList.remove('lw-mnav__layer--pushed');
        }
      });
      drawerObserver.observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    }
  }

  function closeAll() {
    document.querySelectorAll('.lw-mega-nav__item--open').forEach(function (el) {
      el.classList.remove('lw-mega-nav__item--open');
      var link = el.querySelector('.lw-mega-nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    });
    if (overlay) overlay.classList.remove('lw-mega-overlay--active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();